export default __webpack_public_path__ + "media/music/34f108d531b8449c75aba3d062dd71d9.mp3";